"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useMemo } from "react";
import type { SmsConsentVariant } from "@/constants";
import type { BffFacilityFieldsFragment } from "@/lib/__generated/beffe.sdk";
import { useFacilityResolver } from "./useFacilityResolver";
import type { UserCoordinates } from "./useFacilityResolver";
export type FeatureFlags = {
  disableGridLayout: boolean;
  disableFeedbackButton: boolean;
  enableRecaptcha: boolean;
  disableExternalConfirmation: boolean;
  smsConsentVariant: SmsConsentVariant;
};
interface AppContextType {
  deviceType: string;
  stateCode: string;
  restUrl: string;
  recaptchaSiteKey: string;
  currentFacility: BffFacilityFieldsFragment | null;
  featureFlags: FeatureFlags;
  setCurrentFacility: (data: BffFacilityFieldsFragment | null) => void;
  nearbyFacilities: BffFacilityFieldsFragment[];
  setNearbyFacilities: (facilities: BffFacilityFieldsFragment[]) => void;
  reloadFacilityByCode: (code: string) => Promise<void>;
  dayOfServiceOnly: boolean;
}
const AppContext = createContext<AppContextType | undefined>(undefined);
AppContext.displayName = "AspenSchedulingAppContext";
export const AppProvider = t0 => {
  const $ = _c(18);
  const {
    deviceType,
    children,
    facilityCodeCookie,
    userCoordinates,
    stateCode,
    restUrl,
    recaptchaSiteKey,
    featureFlags
  } = t0;
  let t1;
  if ($[0] !== facilityCodeCookie || $[1] !== userCoordinates) {
    t1 = {
      facilityCodeCookie,
      userCoordinates
    };
    $[0] = facilityCodeCookie;
    $[1] = userCoordinates;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    currentFacility,
    setCurrentFacility,
    nearbyFacilities,
    setNearbyFacilities,
    reloadFacilityByCode,
    dayOfServiceOnly
  } = useFacilityResolver(t1);
  let t2;
  if ($[3] !== currentFacility || $[4] !== dayOfServiceOnly || $[5] !== deviceType || $[6] !== featureFlags || $[7] !== nearbyFacilities || $[8] !== recaptchaSiteKey || $[9] !== reloadFacilityByCode || $[10] !== restUrl || $[11] !== setCurrentFacility || $[12] !== setNearbyFacilities || $[13] !== stateCode) {
    t2 = {
      deviceType,
      stateCode,
      restUrl,
      recaptchaSiteKey,
      currentFacility,
      featureFlags,
      setCurrentFacility,
      nearbyFacilities,
      setNearbyFacilities,
      reloadFacilityByCode,
      dayOfServiceOnly
    };
    $[3] = currentFacility;
    $[4] = dayOfServiceOnly;
    $[5] = deviceType;
    $[6] = featureFlags;
    $[7] = nearbyFacilities;
    $[8] = recaptchaSiteKey;
    $[9] = reloadFacilityByCode;
    $[10] = restUrl;
    $[11] = setCurrentFacility;
    $[12] = setNearbyFacilities;
    $[13] = stateCode;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const contextValue = t2;
  let t3;
  if ($[15] !== children || $[16] !== contextValue) {
    t3 = <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
    $[15] = children;
    $[16] = contextValue;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export const useAppContext = () => {
  const ctx = useContext(AppContext);
  if (!ctx) {
    throw new Error("useAppContext must be used inside AppProvider");
  }
  return ctx;
};